import initialState from './initial.state';
import * as types from '../actions/types.action';

export default function branchDetailsReducer(
  state = initialState.branchDetails,
  action
) {
  switch (action.type) {
    case types.SET_BRANCH_DETAILS_SUCCESS:
      return action.branchDetails;
    default:
      return state;
  }
}
